import { NavigationContainer } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { LoginScreen } from "../screens/login";
import { RootStackParamList } from "./Navigation.types";
import MainStack from "./MainStack";
import { AuthGuard, ReverseAuthGuard } from "../components/guard";
import { GameVoteScreen } from "../screens/vote";
import linking from "./LinkingConfiguration";
import { SetPasswordScreen } from "../screens/set-password";
import { ForgotPasswordScreen } from "../screens/forgot-password";
import { ResetPasswordScreen } from "../screens/reset-password";
import { RegisterScreen } from "../screens/register";

const Root = createNativeStackNavigator<RootStackParamList>();

export default function RootNavigation() {
  return (
    <NavigationContainer linking={linking}>
      <Root.Navigator screenOptions={{ headerShown: false }} initialRouteName="main">
        <Root.Screen name="main" component={MainStack} />
        <Root.Screen
          name="login"
          options={{ title: "Login" }}
          children={(props) => (
            <ReverseAuthGuard>
              <LoginScreen />
            </ReverseAuthGuard>
          )}
        />
        <Root.Screen
          name="register"
          options={{ title: "Register" }}
          children={(props) => (
            <ReverseAuthGuard>
              <RegisterScreen />
            </ReverseAuthGuard>
          )}
        />
        <Root.Screen name="set-password" component={SetPasswordScreen} options={{ title: "Set Password" }} />
        <Root.Screen name="reset-password" component={ResetPasswordScreen} options={{ title: "Reset Password" }} />
        <Root.Screen
          name="forgot-password"
          component={ForgotPasswordScreen}
          options={{ title: "Forgot Password", presentation: "modal" }}
        />

        <Root.Screen
          name="vote"
          children={(props) => (
            <AuthGuard>
              <GameVoteScreen {...props} />
            </AuthGuard>
          )}
          options={{ presentation: "modal", title: "Vote" }}
        />
      </Root.Navigator>
    </NavigationContainer>
  );
}
